<template>
	<v-toolbar-items v-if="show" cols="6" md="6" id="menu-nav">
		<div id="menu-nav-desktop" v-if="currentRoute.name != 'Login'" class="d-flex align-center justify-center">
			<router-link
				v-if="!hideEspacePersonnel"
				:to="{ name: 'Profile Index', query: { noLoading: true } }"
				class="pl-3 pr-3 navBarLink"
				:class="{ purpleColor: ['Parcours Detail', 'Profile Index', 'Category Detail'].includes(currentRoute.name) }"
			>
				<span>Espace Personnel</span>
			</router-link>
			<router-link
				:to="{ name: 'Rules' }"
				class="pl-3 pr-3 navBarLink"
				:class="{ purpleColor: currentRoute.name == 'Rules' }"
			>
				<span @click="onDashboardRules()">Espace règles</span>
			</router-link>
			<router-link
				v-if="formationId"
				:to="{ name: 'Orthographiq Assistant', params: { formationId: formationId } }"
				class="pl-3 pr-3 navBarLink"
				:class="{ purpleColor: currentRoute.name == 'Orthographiq Assistant' }"
			>
				<span @click="onDashboardAssistant()">Assistant</span>
			</router-link>
			<router-link
				:to="{ name: 'TestHomePage', query: { topicSlug: 'orthographe', formationId: formationId } }"
				class="pl-3 pr-8 navBarLink"
				:class="{ purpleColor: currentRoute.name == 'TestHomePage' }"
			>
				<TestHomePageNavItem />
			</router-link>
		</div>
	</v-toolbar-items>
</template>

<script>
import { mapActions } from 'vuex';
import { showNavBar } from '@/utils/navbar.js';
import MixPanel from '@/utils/mixpanel.js';
import TestHomePageNavItem from './TestHomePageNavItem.vue';
import { isPastGivenTime } from '@/utils/time.js';

export default {
	name: 'OrthographNavItemsDesktop',
	components: { TestHomePageNavItem },
	props: {
		currentRoute: Object,
		formationId: String,
	},
	computed: {
		show() {
			return showNavBar(this.currentRoute.name);
		},
	},
	data() {
		return { hideEspacePersonnel: false };
	},
	methods: {
		...mapActions('formation', ['getFormationData']),
		onDashboardRules() {
			MixPanel.trackToRule;
		},
		onDashboardAssistant() {
			MixPanel.trackToAssistant;
		},
		async shouldHideEspacePersonnelInDoTestPage() {
			// FIX for DoTestPage Orthographiq, hide Espace Personnel when Orthographiq formation has begin date in future
			if (this.currentRoute.name === 'DoTestPage') {
				if (this.formationId) {
					const formation = await this.getFormationData({ idFormation: this.formationId });
					if (formation) return (this.hideEspacePersonnel = !isPastGivenTime(formation.begin_date));
				} else {
					const { userId } = this.$route.params;
					if (userId) {
						const formations = await this.$store.dispatch('formation/fetchFormationsByUserId', { userId }); // Get all formation of this user
						this.hideEspacePersonnel = formations.some((f) => f.for_session !== true && !isPastGivenTime(f.begin_date));
					}
				}
			}
		},
	},
	async mounted() {
		await this.shouldHideEspacePersonnelInDoTestPage();
	},
};
</script>

<style scoped lang="scss">
#menu-nav-desktop {
	a {
		&:not(:last-child) {
			border-right: 1px solid #989fa9;
		}
	}

	a {
		color: #989fa9 !important;
	}

	a:hover {
		color: #686bdf !important;
	}

	.navBarLink {
		font-weight: 500;
		letter-spacing: 0.0892857143em;
		text-transform: uppercase;
		font-size: 12px;
	}

	.purpleColor {
		color: #686bdf !important;
	}
}
</style>
